import React from 'react';
import PropTypes from 'prop-types';
import { createElementClassName } from '../utils/expandableUtils';

/**
 * Reusable icon component for expandable sections
 */
const ExpandableIcon = ({
  baseClassName,
  position,
  src,
  alt,
  onClick,
  style,
  className,
}) => {
  const iconClassName = createElementClassName(baseClassName, 'icon', position);
  
  return (
    <img 
      className={`${iconClassName} ${className || ''}`}
      onClick={onClick}
      src={src} 
      alt={alt}
      style={style}
    />
  );
};

ExpandableIcon.propTypes = {
  baseClassName: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['left', 'right']).isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default ExpandableIcon;



// WEBPACK FOOTER //
// ./src/components/ExpandableSection/components/ExpandableIcon.js